import React, { useState, useRef } from 'react';
import { Box, Button, Text, Flex, Container, TextArea } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';

const UploadCatalog = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type.startsWith('application/pdf')) {
      setFile(selectedFile);
    } else {
      alert('Please select a valid pdf file');
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      alert('Please select a file first');
      return;
    }

    // Debug log to check file
    console.log('File to upload (PDF):', file);

    const formData = new FormData();
    formData.append('pdf', file, file.name);

    // Debug log to check FormData
    console.log('FormData contents:');
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    try {
      setUploading(true);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/uploadPdf`, {
        method: 'POST',
        body: formData,
      });

      console.log('Response status:', response.status);
      const data = await response.json();
      console.log('Response:', data);

      if (response.ok) {
        alert('Upload successful!');
        setFile(null);
      } else {
        throw new Error(data.error || 'Upload failed');
      }
    } catch (error) {
        console.error('Upload error:', error);
        alert('Error uploading file: ' + error.message);
    } finally {
        setUploading(false);
    }
  };

  return (
    <Container size="2">
      <Box style={{ padding: '2rem' }}>
        <Flex justify="between" align="center" mb="4">
            <Text size="6" weight="bold">อัปโหลดรายการสินค้า / Catalog</Text>
            <Flex gap="2">
                <Button onClick={() => navigate(`/backend/lessons`)} style={{ cursor: 'pointer' }}>
                    กลับไปบทเรียนทั้งหมด
                </Button>
            </Flex>
        </Flex>

        <Flex direction="column" gap="4">
            <input
                ref={fileInputRef}
                type="file"
                accept="application/pdf"
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
            
            <Button 
                variant="outline" 
                onClick={handleButtonClick}
            >
                เลือกไฟล์รายการสินค้า
            </Button>

            {file && (
                <Box>
                <Text size="2" mb="2">Selected file: {file.name} (PDF)</Text>
                <Text size="2" color="gray">
                    Size: {(file.size / (1024 * 1024)).toFixed(2)} MB
                </Text>
                </Box>
            )}

            {uploading && (
                <Box>
                    <div 
                        style={{
                        width: '100%',
                        height: '4px',
                        backgroundColor: '#eee',
                        borderRadius: '2px',
                        }}>
                        <div
                        style={{
                            width: `${progress}%`,
                            height: '100%',
                            backgroundColor: 'var(--accent-9)',
                            borderRadius: '2px',
                            transition: 'width 0.3s ease-in-out',
                        }}
                        />
                    </div>
                </Box>
            )}

            <Button
                disabled={!file || uploading}
                variant="solid"
                onClick={handleSubmit}
            >
                {uploading ? 'กำลังอัปโหลด...' : 'อัปโหลดรายการสินค้า'}
            </Button>
        </Flex>
      </Box>
    </Container>
  );
};

export default UploadCatalog;